import React from "react";
import { useTheme } from "@material-ui/core/styles";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import InstagramIcon from "@material-ui/icons/Instagram";
import FacebookIcon from "@material-ui/icons/Facebook";
import TelegramIcon from "@material-ui/icons/Telegram";
import { Chat } from "@material-ui/icons";

const ConnectionIcon = ({ connectionType, style }) => {
    const theme = useTheme();
    const isDarkMode = theme.mode === "dark";

    const getStyle = (defaultColor) => ({
        marginBottom: '-5px',
        color: defaultColor,
        ...style
    });

    return (
        <React.Fragment>
            {connectionType === 'whatsapp' && <WhatsAppIcon fontSize="small" style={getStyle(isDarkMode ? "#ffffff" : "#000000")} />}
            {connectionType === 'whatsapp_oficial' && <WhatsAppIcon fontSize="small" style={getStyle("#25D366")} />}
            {connectionType === 'instagram' && <InstagramIcon fontSize="small" style={getStyle("#e1306c")} />}
            {connectionType === 'facebook' && <FacebookIcon fontSize="small" style={getStyle(isDarkMode ? "#00E5FF" : "#3b5998")} />}
            {connectionType === 'telegram' && <TelegramIcon fontSize="small" style={getStyle("#0088cc")} />}
            {connectionType === 'webchat' && <Chat fontSize="small" style={getStyle("#25D366")} />}
        </React.Fragment>
    );
};

export default ConnectionIcon;
